<template>
  <div>
    <v-card class="pt-3 pb-3 mb-3">
      <v-row>
        <v-card-title>
          <h2 class="text-xl">UTM Content suivis</h2>
        </v-card-title>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            class="ml-6 mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Recherche"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            class="ml-6 mr-6"
            :items="items"
            :headers="headers"
            :search="search"
          >
            <template v-slot:[`item.content`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="truncate-cell" v-bind="attrs" v-on="on">
                    {{ item.content }}
                  </div>
                </template>
                <span>{{ item.content }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.is_active="{ item }">
              <v-chip :color="item.is_active ? 'success' : 'secondary'" small>
                {{ item.is_active ? "Actif" : "Inactif" }}
              </v-chip>
            </template>
            <template v-slot:item.edit="{ item }">
              <div>
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="editContent(item)"
                >
                  <v-icon color="primary">
                    {{ icons.mdiPencil }}
                  </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="deleteContent(item)"
                >
                  <v-icon color="secondary">
                    {{ icons.mdiTrashCan }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="contentDialog" max-width="600px">
      <v-card>
        <v-card-title>Modifier l'UTM Content</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="content.content"
                label="Content"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="content.label"
                label="Label"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-switch
                v-model="content.is_active"
                label="Actif"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="updateContent">Enregistrer</v-btn>
          <v-btn color="secondary" @click="cancelContent">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.truncate-cell {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>

<script>
import useAxios from "@/hooks/useAxios";
import debounce from "lodash/debounce";
import { mdiPencil, mdiTrashCan } from "@mdi/js";

export default {
  name: "utmContentWhitelistTable",
  components: {},

  data() {
    return {
      search: "",
      items: [],
      headers: [
        { text: "Content", value: "content" },
        { text: "Label", value: "label" },
        { text: "Statut", value: "is_active" },
        { text: "Actions", value: "edit", sortable: false },
      ],
      icons: {
        mdiPencil,
        mdiTrashCan,
      },
      contentDialog: false,
      content: {
        id: "",
        content: "",
        label: "",
        is_active: true,
      },
    };
  },

  setup() {
    const { axiosGet, axiosPost, axiosPut, axiosDelete, isLoading } =
      useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
      axiosPut,
      axiosDelete,
    };
  },

  methods: {
    debouncedUpdateData: debounce(async function () {
      await this.getData();
    }, 500),
    async getData() {
      const response = await this.axiosGet("/acquisition/utm-content/");
      this.items = response.data;
    },
    async cancelContent() {
      this.content = {
        id: "",
        content: "",
        label: "",
        is_active: true,
      };
      this.contentDialog = false;
      this.getData();
    },
    async editContent(item) {
      this.content = { ...item };
      this.contentDialog = true;
    },
    async updateContent() {
      const payload = {
        content: this.content.content,
        label: this.content.label,
        is_active: this.content.is_active,
      };
      try {
        await this.axiosPut(
          `/acquisition/utm-content/${this.content.id}`,
          payload
        );
      } catch (error) {
        console.error("Error saving UTM Content:", error);
        alert(
          "Erreur lors de la mise à jour de l'UTM Content. Vérifier l'intégrité des données (doublons)."
        );
        this.cancelContent();
      }
      this.contentDialog = false;
      this.getData();
    },
    async deleteContent(item) {
      this.content = item;
      await this.axiosDelete(`/acquisition/utm-content/${this.content.id}`);
      this.getData();
    },
  },

  async created() {
    await this.getData();
  },
  computed: {},
};
</script>
